var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-field',{attrs:{"control":_vm.control,"loading":_vm.loading}},[_c('app-select',{attrs:{"control":_vm.control,"options":_vm.companies,"disabled":_vm.loading || _vm.disabled,"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }